<div *ngIf="params.data" class="btn-div">
  <ul class="list-group" *ngIf="!params.data.isSystem">
    <li class="style-none">
      <div
        ngbDropdown
        class="d-inline-block"
        (openChange)="isDropdownActive = !isDropdownActive"
        *ngIf="!isOrigin"
      >
        <button class="btn" id="action-btn" ngbDropdownToggle>
          <svg
            width="24"
            height="4"
            viewBox="0 0 24 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            [ngClass]="{ active: isDropdownActive }"
          >
            <path
              d="M4.18988 3.96H0.669875V0.44H4.18988V3.96ZM13.6274 3.96H10.1074V0.44H13.6274V3.96ZM23.0649 3.96H19.5449V0.44H23.0649V3.96Z"
              fill="black"
            />
          </svg>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-styles dropdownmys">
          <!-- <button ngbDropdownItem *ngIf="params.showView" href="javascript:void(0)" id="btnviewProject"
          title="{{ params.viewLabel }}" (click)="viewProject($event)">
          
          <span class="textDrp">View</span>
        </button> -->
          <button
            ngbDropdownItem
            *ngIf="params.showEdit && !params.data?.isSystem && !isShowEdit"
            href="javascript:void(0)"
            id="btnEditProject"
            (click)="editProject()"
            title="{{ params.editLabel }}"
          >
            <span class="textDrp">Edit</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showExport"
            href="javascript:void(0)"
            id="btnEditProject"
            (click)="exportToExcel()"
            title="{{ params.editLabel }}"
          >
            <span class="textDrp">Export</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showCopy"
            href="javascript:void(0)"
            id="btnCopyProject"
            title="{{ params.copyLabel }}"
            (click)="copyProject()"
            [disabled]="disableSubmit"
          >
            <span class="textDrp">Copy</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="
              params.showDelete && !params.data.isSystem && !isShowDelete && !isShowDeleteImports
            "
            href="javascript:void(0)"
            title="{{ params.deleteLabel }}"
            (click)="deleteProject()"
          >
            <span class="textDrp">Delete</span>
          </button>

          <button
            ngbDropdownItem
            *ngIf="params.showView && activeRoute !== 'dashboard' && !isShowEdit"
            href="javascript:void(0)"
            id="btnviewProject"
            title="{{ params.viewLabel }}"
            (click)="viewProject($event)"
          >
            <span class="textDrp">{{ params.viewLabel || 'View' }}</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showHide && params?.data?.role === 'Super Admin'"
            href="javascript:void(0)"
            id="btnviewProject"
            (click)="hideUnhideFunction()"
          >
            <span class="textDrp">{{
              params.data?.isProjectVisible || params.data?.isVisible || activeRoute === 'dashboard'
                ? 'Hide'
                : 'Unhide'
            }}</span>
          </button>

          <button
            ngbDropdownItem
            *ngIf="params.showDetails && !params.data.isSystem"
            href="javascript:void(0)"
            title="{{ params.detailLable }}"
            (click)="showDetails()"
          >
            <span class="textDrp">View history</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showInvoice && !params.data.isSystem"
            href="javascript:void(0)"
            title="{{ params.invoiceLable }}"
            (click)="showInvoice()"
          >
            <span class="textDrp">Invoice</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.invoiceDownload && !params.data.isSystem"
            href="javascript:void(0)"
            title="Download"
            (click)="invoiceDownload()"
          >
            <span class="textDrp">Download</span>
          </button>
          <button
            [ngClass]="params.isDisabledBookMarked ? 'bookmark-disabled' : ''"
            ngbDropdownItem
            *ngIf="
              activeRoute == 'material-list' ||
              (activeRoute == 'organizationPreferences' && params.isBookMarkGrid)
            "
            href="javascript:void(0)"
            title="{{
              params.data.isBookmarked || activeRoute == 'organizationPreferences'
                ? 'Unbookmark'
                : 'Bookmark'
            }}"
            (click)="updateBookMark()"
          >
            <span class="textDrp">{{
              params.data.isBookmarked || activeRoute == 'organizationPreferences'
                ? 'Unbookmark'
                : 'Bookmark'
            }}</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.isAutomationGrid"
            href="javascript:void(0)"
            title="Test"
            (click)="testAutomation()"
          >
            <span class="textDrp">Test</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.isAutomationGrid"
            href="javascript:void(0)"
            title="Analytics"
            (click)="automationAnalytics()"
          >
            <span class="textDrp">Analytics</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.isImportProjectLogGrid"
            href="javascript:void(0)"
            title="Download"
            (click)="downloadFile()"
          >
            <span class="textDrp">{{ params.isActionRequired ? 'Edit' : 'Download' }}</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.isReEnqueue"
            href="javascript:void(0)"
            title="Re-Enqueue"
            (click)="reEnqueueFile()"
          >
            <span class="textDrp">{{ params.isActionRequired ? 'Edit' : 'Re-Enqueue' }}</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showImport"
            href="javascript:void(0)"
            title="Import"
            (click)="importFile()"
          >
            <span class="textDrp">Import</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showSetActive"
            href="javascript:void(0)"
            title="Set as active version"
            (click)="setActiveVersion()"
          >
            <span class="textDrp">Set active</span>
          </button>
          <button
            ngbDropdownItem
            *ngIf="params.showArchive"
            href="javascript:void(0)"
            title="Archive this version"
            (click)="archiveVersion()"
          >
            <span class="textDrp">Archive</span>
          </button>
        </div>
      </div>
    </li>
  </ul>
</div>

<!-- (click)="params.isInline ? editProject($event) : viewProject()" -->
